/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesAccsNecktieIcon16Solid = forwardRef('ClothesAccsNecktieIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.6 4.861c-.21.247-.41.45-.578.608l2.238 5.54a1.5 1.5 0 0 1-.33 1.622L9.06 15.5a1.5 1.5 0 0 1-2.12 0l-2.87-2.869a1.5 1.5 0 0 1-.33-1.622L5.98 5.467a7.418 7.418 0 0 1-.573-.606c-.52-.615-1.122-1.535-1.347-2.687C3.933 1.529 4.446 1 5.033 1h5.936c.584 0 1.097.524.976 1.167-.218 1.157-.824 2.079-1.345 2.694Z" })));
});
